import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from "@mui/material";

export default function DeleteConfirmationDialog({
  open,
  onClose,
  onConfirm,
  loading,
  rubricCategory
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Rubric</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete the rubric &quot;{rubricCategory}&quot;?
          This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={loading}
        >
          {loading ? "Deleting..." : "Confirm Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
